export default __webpack_public_path__ + "static/royal-kensington-ab25fea19e4723f5aa2e9bb0429e762b.png";